import React from "react";
import {Select, MenuItem, FormControl} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {blue} from "@mui/material/colors";
import {BOOKABLE_STATUS} from "../../domain/BookableStatus";

export default function BookableSelectionButton({onStatusChange, bookableStatus}) {

    const PERFORMER_SELECTED_DARK_BLUE_COLOR = blue[700];
    
    const bookableStatusDropdownStyle = {
        backgroundColor: PERFORMER_SELECTED_DARK_BLUE_COLOR,
        color: 'white',
        borderRadius: '1rem',
        height: 35,
        width: 135
    };

    const handleStatusChange = (event) => {
        const newStatus = event.target.value;
        onStatusChange(newStatus);
    };

    return <FormControl>
        <Select
            value={bookableStatus}
            onChange={handleStatusChange}
            size="small"
            style={bookableStatusDropdownStyle}
            IconComponent={props => <ArrowDropDownIcon {...props} style={{color: 'white'}}/>}
            MenuProps={{MenuListProps: {sx: {paddingBottom: 0}}}}>
                <MenuItem value={BOOKABLE_STATUS.Bookable}>{BOOKABLE_STATUS.Bookable}</MenuItem>
                <MenuItem value={BOOKABLE_STATUS.Unbookable}>{BOOKABLE_STATUS.Unbookable}</MenuItem>
        </Select>
    </FormControl>;
}
